import { render, staticRenderFns } from "./TemplatesTab.vue?vue&type=template&id=3a6a9c8a&scoped=true&"
import script from "./TemplatesTab.vue?vue&type=script&lang=js&"
export * from "./TemplatesTab.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesTab.vue?vue&type=style&index=0&id=3a6a9c8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a9c8a",
  null
  
)

export default component.exports